import { API_URL } from 'config';
import { makeAPICall } from 'models/api';

export declare namespace API {
    export interface FaftWorkTypes {
        plan_id: string;
        faft_id: string;
        year1: string[];
        year2: string[];
        year3: string[];
        year4: string[];
        year5: string[];
    }

    export interface FaftWorkTypeDescriptions {
        work_type: string;
        work_type_description: string;
    }
}

export interface FaftWorkTypes {
    planId: string;
    faftId: string;
    year1: string[];
    year2: string[];
    year3: string[];
    year4: string[];
    year5: string[];
}

export interface ActionResponse {
    success: boolean;
    error?: string;
}

export interface FaftWorkTypeDescriptions {
    workType: string;
    workTypeDescription: string;
}

export const mapAPIToFaftWorkTypes = ({
    plan_id,
    faft_id,
    year1,
    year2,
    year3,
    year4,
    year5,
    ...rest
}: API.FaftWorkTypes): FaftWorkTypes => ({
    ...rest,
    planId: plan_id,
    faftId: faft_id,
    year1: year1,
    year2: year2,
    year3: year3,
    year4: year4,
    year5: year5,
});

export const mapAPIToFaftWorkTypeDescriptions = ({
    work_type,
    work_type_description,
}: API.FaftWorkTypeDescriptions): FaftWorkTypeDescriptions => ({
    workType: work_type,
    workTypeDescription: work_type_description,
});

export const getFaftWorkTypes = makeAPICall<
    FaftWorkTypes | undefined,
    {
        planId: string;
        faftId: string;
    },
    API.FaftWorkTypes
>(
    ({ planId, faftId }) => {
        return {
            url: `${API_URL}/faft/prioritisation/${planId}/workregister/${faftId}`,
        };
    },
    (raw) => {
        if (raw) return mapAPIToFaftWorkTypes(raw);
    },
);

export const updateFaftWorkTypes = makeAPICall<
    FaftWorkTypes,
    {
        planId: string;
        faftId: string;
        workTypesData: WorkTypesData; // Assumes `WorkTypes` maps directly to the API model structure.
    },
    API.FaftWorkTypes
>(
    ({ planId, faftId, workTypesData }) => {
        return {
            url: `${API_URL}/faft/prioritisation/${planId}/workregister/${faftId}`,
            requestData: {
                contentType: 'application/json',
                method: 'PUT',
                body: JSON.stringify(workTypesData),
            },
        };
    },
    (raw) => mapAPIToFaftWorkTypes(raw),
);

export const deleteFaftWorkTypes = makeAPICall<
    ActionResponse,
    { planId: string; faftId: string },
    ActionResponse
>(
    ({ planId, faftId }) => {
        if (!faftId || !planId) {
            throw Error('Missing argument no fire trail id or plan found.');
        }
        return {
            url: `${API_URL}/faft/prioritisation/${planId}/workregister/${faftId}`,
            contentType: null,
            requestData: {
                method: 'DELETE',
            },
        };
    },
    (data) => {
        return data;
    },
);

export const getFaftWorkTypeDescriptions = makeAPICall<
    FaftWorkTypeDescriptions[],
    void,
    API.FaftWorkTypeDescriptions[]
>(
    () => {
        return {
            url: `${API_URL}/faft/prioritisation/workregister/worktypedescriptions`,
        };
    },
    (raw) => raw.map((wtd) => mapAPIToFaftWorkTypeDescriptions(wtd)),
);

export type WorkTypesData = {
    year1?: string[];
    year2?: string[];
    year3?: string[];
    year4?: string[];
    year5?: string[];
};
